export default (webId) => '/profile?webId=' + encodeURIComponent(webId);